module.exports = __webpack_public_path__ + "static/ProfessionalEmployee-d522f70c219923fb2ffb618419a3075b.jpg";